import { useEffect, useState } from "react";
import { ICommentProps } from "../../../../../shared/utils/interfaces/commentsFaces";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import ProfileImage from "../../../../../shared/components/NavBar/profileImage";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../../authentication/slice/authSlice";
import { selectIsEditingComment } from "../../../slice/candidateSlice";

export default function Comment({ name, postedAt, text, id, onEdit, onDelete, updatedAt, userId }: ICommentProps) {
    const user = useSelector(selectCurrentUser);
    const isEditing = useSelector(selectIsEditingComment);
    const [postedSince, setPostedSince] = useState<string>();
    const [updatedSince, setUpdatedSince] = useState<string>();
    const [isHovered, setIsHovered] = useState(false);
    const [canHover, setCanHover] = useState(false);

    useEffect(() => {
        dayjs.extend(relativeTime)
        setPostedSince(dayjs().to(dayjs(postedAt)))
        setUpdatedSince(dayjs().to(dayjs(updatedAt)))
    }, [postedAt, updatedAt])

    useEffect(() => {
        // Check if device supports hover
        const mq = window.matchMedia('(hover: hover)');
        setCanHover(mq.matches);
    }, []);

    return (
        <div
            className='flex items-start gap-[0.875rem] mt-4 mb-5 flex-nowrap pe-2 transition-all duration-300 ease-in-out'
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <ProfileImage name={name} className="-mt-1" />
            <div>
                <div className='flex items-center flex-nowrap mb-1.5'>
                    <span className='text-sm font-semibold text-gray-600 me-2'>{name}</span>
                    <span className='text-xs font-normal text-gray-400 whitespace-nowrap'><span className="mr-1">{updatedAt ? 'Edited' : ''}</span> {updatedAt ? updatedSince : postedSince} {isHovered && !isEditing && canHover && <> <span className="hidden ml-1 lg:inline">|</span>
                            <span className="inline">
                                <span className={`mx-2 text-gray-600 cursor-pointer ${user?.id !== userId ? 'grayscale opacity-30 cursor-not-allowed' : ''}`} onClick={() => onEdit(id, userId)}>Edit</span>
                                <span className={`text-red-500 cursor-pointer ${user?.id !== userId ? 'opacity-30 cursor-not-allowed' : ''}`} onClick={() => onDelete(id, userId)}>Delete</span>
                            </span>
                    </>
                    }
                    </span>
                </div>
                <span className='text-gray-600 break-words min-w-fit'>{text}</span>
                {!canHover && (
                    <div className="block mt-2.5 text-xs">
                        <span className={`mr-2 text-gray-600 cursor-pointer ${isEditing || user?.id !== userId ? 'grayscale opacity-30 cursor-not-allowed' : ''}`} onClick={() => onEdit(id, userId)}>Edit</span>
                        <span className={`text-red-500 cursor-pointer ${isEditing || user?.id !== userId ? 'opacity-30 cursor-not-allowed' : ''}`} onClick={() => onDelete(id, userId)}>Delete</span>
                    </div>
                )}
            </div>
        </div>
    )
}